import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type GetMessagesForThreadQueryVariables = Types.Exact<{
   params: Types.GetMessagesForThreadParams
}>

export type GetMessagesForThreadQuery = {
   __typename?: 'Query'
   getMessagesForThread:
      | {
           __typename?: 'GetMessagesForThreadResult'
           totalCount: number
           messages: Array<{
              __typename?: 'ThreadMessage'
              messageId: number
              timestamp: string
              date: string
              content: string
              senderId: string
           }>
        }
      | { __typename?: 'InvalidLimit'; message?: string | null }
      | { __typename?: 'InvalidOffset'; message?: string | null }
      | { __typename?: 'ThreadAccessDenied' }
      | { __typename?: 'ThreadNotFound' }
}

export const GetMessagesForThreadDocument = gql`
   query GetMessagesForThread($params: GetMessagesForThreadParams!) {
      getMessagesForThread(params: $params) {
         ... on GetMessagesForThreadResult {
            messages {
               messageId
               timestamp
               date
               content
               senderId
            }
            totalCount
         }
         ... on InvalidOffset {
            message
         }
         ... on InvalidLimit {
            message
         }
      }
   }
`
export type GetMessagesForThreadQueryResult = Apollo.QueryResult<
   GetMessagesForThreadQuery,
   GetMessagesForThreadQueryVariables
>
